/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import * as actionTypes from './UpdateCart-ActionTypes';

export const updateOrder = (payload, updateOrderProps, callback) => ({
    type: actionTypes.UPDATE_ORDER,
    data: payload,
    updateOrderProps,
    callback,
});

export default {};
